import { AdjustmentStatusEnum, StatusToneEnum } from '@ztechapps/common.contract'

export const AdjustmentStatus = {
  Draft: {
    value: AdjustmentStatusEnum.Draft,
    description: 'The work order have not started yet',
    sort: 0,
    tone: StatusToneEnum.Draft,
  },
  InProgress: {
    value: AdjustmentStatusEnum.InProgress,
    description: 'The work order has started',
    sort: 1,
    tone: StatusToneEnum.InProgress,
  },

  Complete: {
    value: AdjustmentStatusEnum.Complete,
    description: 'The work order is done.',
    sort: 2,
    tone: StatusToneEnum.Active,
  },

  Cancelled: {
    value: AdjustmentStatusEnum.Cancelled,
    description: 'The work order has been cancelled.',
    sort: 3,
    tone: StatusToneEnum.Cancelled,
  },
}
